import { render, staticRenderFns } from "./adminDialog.vue?vue&type=template&id=984badbe&scoped=true&params=type"
import script from "./adminDialog.vue?vue&type=script&lang=js"
export * from "./adminDialog.vue?vue&type=script&lang=js"
import style0 from "./adminDialog.vue?vue&type=style&index=0&id=984badbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984badbe",
  null
  
)

export default component.exports